<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'KioskLayout',
})
</script>

<template>
  <v-container id="kiosk-layout" fluid pa-0>
    <router-view :key="$route.fullPath" />
  </v-container>
</template>

<style lang="scss" scoped>
#kiosk-layout {
  height: 100%;
}
</style>
